import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SHOW_COMMENT: "Vis kommentar",
      HIDE_COMMENT: "Skjul kommentar",
      ADD_A_COMMENT: "Legg til en kommentar",
      CHANGE_COMMENT: "Endre kommentar",
    },
    se: {
      SHOW_COMMENT: "Visa kommentar",
      HIDE_COMMENT: "Göm kommentar",
      ADD_A_COMMENT: "Lägg till en kommentar",
      CHANGE_COMMENT: "Ändra kommentar",
    },
    dk: {
      SHOW_COMMENT: "Vis kommentar",
      HIDE_COMMENT: "Skjul kommentar",
      ADD_A_COMMENT: "Tilføj en kommentar",
      CHANGE_COMMENT: "Rediger kommentar",
    },
  } as const
)[language];
